import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CourseMetadata } from 'types';

import './styles.scss';
import { withErrorBoundary } from 'react-error-boundary';
import { handleError } from 'services/ErrorService';

const ErrorMessage = () => {
  const { t } = useTranslation();

  return <p>{t('Extra information not available')}</p>;
};

interface FoundationCollateralProps {
  metadata: CourseMetadata;
  language?: string;
}

const FoundationMetadata: React.FC<FoundationCollateralProps> = ({
  metadata,
  language = 'en-US',
}) => {
  const { t } = useTranslation();

  const metadataForLang = useMemo(() => {
    if (metadata) {
      let description = metadata.description?.[language];

      if (!description) {
        description = metadata.description?.['en-US'];
      }

      let prerequisites = metadata.prerequisites?.[language];

      if (!prerequisites) {
        prerequisites = metadata.prerequisites?.['en-US'];
      }

      let audience = metadata.audience?.[language];

      if (!audience) {
        audience = metadata.audience?.['en-US'];
      }

      return {
        description,
        prerequisites,
        audience,
      };
    }

    return null;
  }, [metadata, language]);

  return (
    <div className="foundation-metadata">
      {metadataForLang && (
        <>
          {metadataForLang.description && (
            <>
              <h3 className="foundation-metadata__heading">
                {t('Description')}
              </h3>
              <p className="foundation-metadata__content">
                {metadataForLang.description}
              </p>
            </>
          )}

          {metadataForLang.audience?.length && (
            <>
              <h3 className="foundation-metadata__heading">{t('Audience')}</h3>
              <ul className="foundation-metadata__list">
                {metadataForLang.audience.map?.((a) => (
                  <li key={a}>{a}</li>
                ))}
              </ul>
            </>
          )}

          {metadataForLang.prerequisites?.length && (
            <>
              <h3 className="foundation-metadata__heading">
                {t('Prerequisites')}
              </h3>
              <ul className="foundation-metadata__list">
                {metadataForLang.prerequisites.map?.((pr) => (
                  <li key={pr}>{pr}</li>
                ))}
              </ul>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default withErrorBoundary(FoundationMetadata, ErrorMessage, handleError);
